export const img = new Image();
img.src = require("./assets/img/myProjectMap.png");

export const foreground = new Image();
foreground.src = require("./assets/img/Foreground.png");

export const foreground2 = new Image();
foreground2.src = require("./assets/img/Foreground2.png");

export const playerDown = new Image();
playerDown.src = require("./assets/img/playerDown.png");

export const playerUp = new Image();
playerUp.src = require("./assets/img/playerUp.png");

export const playerLeft = new Image();
playerLeft.src = require("./assets/img/playerLeft.png");

export const playerRight = new Image();
playerRight.src = require("./assets/img/playerRight.png");

export const npcMap = new Image();
npcMap.src = require("./assets/img/npcMap.png");

export const house = new Image();
house.src = require("./assets/img/house1_550.png");

export const houseForeground = new Image();
houseForeground.src = require("./assets/img/house1Foreground.png");

export const city = new Image();
city.src = require("./assets/img/city.png");

export const cityForeground = new Image();
cityForeground.src = require("./assets/img/cityForeground.png");

export const chestImg = new Image();
chestImg.src = require("./assets/img/chest.png");

export const openChest = new Image();
openChest.src = require("./assets/img/chest2.png");
